import type { DialogueView } from "../sim/neighborhood/index.ts";

export interface DialogueUi {
  setPrompt(label: string | null): void;
  setObjective(label: string | null): void;
  open(
    view: Readonly<DialogueView>,
    onChoice: (choiceId: string) => void,
  ): void;
  close(): void;
  isOpen(): boolean;
  dispose(): void;
}

export function createDialogueUi(root: HTMLElement): DialogueUi {
  const prompt = document.createElement("div");
  prompt.className = "interaction-prompt";
  prompt.hidden = true;
  const key = document.createElement("kbd");
  key.textContent = "E";
  const promptText = document.createElement("span");
  prompt.append(key, promptText);

  const objective = document.createElement("aside");
  objective.className = "quest-objective";
  objective.hidden = true;
  objective.setAttribute("aria-live", "polite");

  const panel = document.createElement("section");
  panel.className = "dialogue-panel";
  panel.hidden = true;
  panel.setAttribute("aria-live", "polite");
  const speaker = document.createElement("p");
  speaker.className = "dialogue-speaker";
  const line = document.createElement("p");
  line.className = "dialogue-line";
  const choices = document.createElement("div");
  choices.className = "dialogue-choices";
  panel.append(speaker, line, choices);
  root.append(prompt, objective, panel);

  return {
    setPrompt(label): void {
      prompt.hidden = label === null || !panel.hidden;
      promptText.textContent = label ?? "";
    },
    setObjective(label): void {
      objective.hidden = label === null;
      objective.textContent = label ?? "";
    },
    open(view, onChoice): void {
      prompt.hidden = true;
      panel.hidden = false;
      speaker.textContent = view.speaker;
      line.textContent = view.line;
      choices.replaceChildren();
      const available = view.choices.length > 0
        ? view.choices
        : [{ id: "leave", label: "Continue." }];
      for (const [index, choice] of available.entries()) {
        const button = document.createElement("button");
        button.type = "button";
        button.dataset.choiceId = choice.id;
        button.textContent = `${index + 1} · ${choice.label}`;
        button.addEventListener("click", () => onChoice(choice.id), {
          once: true,
        });
        choices.append(button);
      }
    },
    close(): void {
      panel.hidden = true;
      choices.replaceChildren();
    },
    isOpen(): boolean {
      return !panel.hidden;
    },
    dispose(): void {
      prompt.remove();
      objective.remove();
      panel.remove();
    },
  };
}
